
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2d3748] py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Left Column */}
          <div className="space-y-6">
            <img 
              src="https://static.readdy.ai/image/57253257ce2fc83925052891bf004756/264fa5438bc5a5dc88c73fbd09ddf478.jpeg" 
              alt="Atlas Contractor Solutions Logo" 
              className="h-10 w-auto"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              AI-powered business platform for contractors
            </p>
            <div className="inline-flex items-center gap-3 bg-[#1a202c] border-l-3 border-[#ff6b35] px-4 py-3 rounded">
              <i className="ri-flashlight-fill text-[#ff6b35]"></i>
              <span className="text-sm text-gray-300">Currently in development</span>
            </div>
          </div>

          {/* Middle Column */}
          <div>
            <h3 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-5">
              Company
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  About
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Privacy
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Terms
                </a>
              </li>
            </ul>
          </div>

          {/* Right Column */}
          <div>
            <h3 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-5">
              Connect
            </h3>
            <div className="flex gap-3">
              <a 
                href="#" 
                className="w-10 h-10 bg-[#1a202c] rounded-full flex items-center justify-center text-white hover:bg-[#ff6b35] transition-all cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-[#1a202c] rounded-full flex items-center justify-center text-white hover:bg-[#ff6b35] transition-all cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-[#1a202c] rounded-full flex items-center justify-center text-white hover:bg-[#ff6b35] transition-all cursor-pointer"
                aria-label="Email"
              >
                <i className="ri-mail-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>
              © {currentYear} ContractorAI. Built for contractors, by people who get it.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#ff6b35] transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
